import React, { useState, useCallback, useEffect } from "react";
import { object, func } from "prop-types";

import { toBanglaString } from "../../../utils/utils";

import "./spinner.m.css";

const Spinner = ({ prayer, currnet }) => {
  if (!(prayer && prayer.times.valids)) return null;

  const [spinnerTime, setSpinnerTime] = useState({});
  const [activePrayer, setActivePrayer] = useState({});

  useEffect(() => {
    if (activePrayer) {
      currnet(activePrayer?.index);
    }
  }, [activePrayer]);

  useEffect(() => {
    const { seconds = 0 } = spinnerTime;
    if (seconds !== undefined) {
      // f = first child, s = second child, t = third child
      const [f, s, t] = document.getElementById("seconds").children;
      timeChange(f, seconds);
      timeChange(s, seconds);
      timeChange(t, seconds);
    }
  }, [spinnerTime.seconds]);

  useEffect(() => {
    const { minutes = 0 } = spinnerTime;
    if (minutes !== undefined) {
      // f = first child, s = second child, t = third child
      const [f, s, t] = document.getElementById("minutes").children;
      timeChange(f, minutes);
      timeChange(s, minutes);
      timeChange(t, minutes);
    }
  }, [spinnerTime.minutes]);

  useEffect(() => {
    const { hours } = spinnerTime;
    if (hours !== undefined) {
      // f = first child, s = second child, t = third child
      const [f, s, t] = document.getElementById("hours").children;
      timeChange(f, hours);
      timeChange(s, hours);
      timeChange(t, hours);
    }
  }, [spinnerTime.hours]);

  const timeChange = (element, n) => {
    const top = element.style.top;
    n = parseInt(n);
    if (top === "-30px") {
      element.style.top = "30px";
      element.style.zIndex = -1;
      element.textContent = toBanglaString(n === 0 ? "00" : n - 1 < 10 ? `0${n}` : n);
    } else if (top === "0px") {
      element.style.top = "-30px";
      element.textContent = toBanglaString(n + 1 === 60 ? "00" : n < 10 ? `0${n}` : n);
    } else if (top === "30px") {
      element.style.top = 0;
      element.style.zIndex = 0;
      element.textContent = toBanglaString(n < 10 ? `0${n}` : n);
    }
  };

  const intervalCallback = useCallback(() => {
    const active = prayer?.activePrayer;
    const { startTime, endTime } = active || {};

    setActivePrayer(active);

    const totalTime = endTime - startTime;

    const date = new Date();
    const duration = Math.abs(date - endTime);

    let delta = duration / 1000; // miliseconds to seconds

    const days = Math.floor(delta / 86400);
    // seconds to days

    delta -= days * 86400;
    // converted days to seconds
    // deduct the seconds from delta
    // now delta have hours as seconds

    const hours = Math.floor(delta / 3600) % 24;
    // converted seconds to hour

    delta -= hours * 3600;
    // converted hours to seconds
    // deduct the seconds from delta
    // now delta have minutes as seconds

    const minutes = Math.floor(delta / 60) % 60;
    // converted seconds to minutes

    delta -= minutes * 60;
    // converted minutes to seconds
    // deduct the seconds from delta
    // now delta have seconds

    const seconds = delta % 60;
    // now delta have reminder of seconds

    const spin = Math.floor((288 * (totalTime - duration)) / totalTime);

    setSpinnerTime({
      stroke: spin,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    });
  });

  useEffect(() => {
    let interval;
    if (prayer && prayer.activePrayer) {
      interval = setInterval(intervalCallback, 1000);
    }

    return () => clearInterval(interval);
  }, [prayer]);

  const getCounter = (key) => {
    return (
      <span styleName="count-container">
        <span styleName="count" id={key}>
          <span styleName="count-item" style={{ top: -30 }}></span>
          <span styleName="count-item" style={{ top: 0 }}></span>
          <span styleName="count-item" style={{ top: 30 }}></span>
        </span>
      </span>
    );
  };

  return (
    <div styleName={`spinner ${activePrayer?.type || ""}`}>
      <svg styleName="spinner-circle" viewBox="0 0 100 100">
        <circle styleName="spinner-bg" cx="50" cy="50" r="46" />
        <circle
          strokeMiterlimit="10"
          style={{ strokeDashoffset: spinnerTime.stroke || 0 }}
          styleName="loader"
          cx="50"
          cy="50"
          r="46"
        />
      </svg>
      <div styleName="spinner-texts">
        <div styleName="prayer-name">{activePrayer?.name}</div>
        <div styleName="prayer-time">ওয়াক্ত শুরু হতে বাকি </div>
        <div styleName="prayer-left-count">
          <span styleName="counts">
            <span styleName="count-hour">{getCounter("hours")}</span>
            <span styleName="count-text">ঘণ্টা</span>
          </span>
          <span styleName="counts">
            <span styleName="count-minutes">{getCounter("minutes")}</span>
            <span styleName="count-text">মিনিট</span>
          </span>
          <span styleName="counts">
            <span styleName="count-seconds">{getCounter("seconds")}</span>
            <span styleName="count-text">সেকেন্ড</span>
          </span>
        </div>
      </div>
    </div>
  );
};

Spinner.propTypes = {
  prayer: object,
  currnet: func,
};

export default Spinner;
